import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { AXIOS_TIMEOUT } from '../utils/constants';
import tabbarSlice from '../components/Tabbar/tabbarSlice';
import selectedDesignSlice from '../redux/slices/selectedDesignSlice';
import userSlice from '../redux/slices/userSlice';

const useFetchData = (fetchDesignData, disabledTabs) => {
	const [hasError, setHasError] = useState(false);
	const icPartNumber = useSelector(state => state.selectedDesign.icPartNumber);
	const inputParametersDL = useSelector(state => state.designList.inputParameters);
	const openMyDesign = useSelector(state => state.selectedDesign.openMyDesign);
	const myDesignId = useSelector(state => state.selectedDesign.myDesign.id);
	const topology = useSelector(state => state.selectedDesign.topology);
	const userLoggedIn = useSelector(state => state.user.loggedIn);
	const userId = useSelector(state => state.user.id);
	const dispatch = useDispatch();

	const newDesignRequest = {
		method: 'post',
		url: 'api/calc/designDetail',
		data: {
			designDescription: {
				icPartNumber,
				inputParameters: inputParametersDL,
				bomComponents: null,
				topology
			},
			userId
		},
		timeout: AXIOS_TIMEOUT
	};

	const openDesignRequest = {
		method: 'get',
		url: 'api/calc/designDetail/' + myDesignId,
		timeout: AXIOS_TIMEOUT
	};

	useEffect(() => {
		if (!fetchDesignData || disabledTabs.Summary || disabledTabs.Design) return;
		const timer = setTimeout(() => {
			axios(openMyDesign ? openDesignRequest : newDesignRequest)
				.then(response => {
					try {
						if (response.data) {
							response.data.designDetail = JSON.parse(response.data.designDetail);

							dispatch(selectedDesignSlice.actions.setDetail(response.data.designDetail));
							dispatch(selectedDesignSlice.actions.setInitialInputParameters(response.data.inputParameters));
							dispatch(
								selectedDesignSlice.actions.setMyDesignData({
									id: response.data.myDesign.id,
									name: response.data.myDesign.name,
									dateCreated: response.data.myDesign.dateCreated,
									dateModified: response.data.myDesign.dateModified
								})
							);

							if (userLoggedIn && userId !== null) {
								dispatch(userSlice.actions.updateMyDesignInTable(response.data.myDesign));
							}

							if (openMyDesign) {
								dispatch(
									selectedDesignSlice.actions.setIcPartNumber(response.data.designDetail.rankingParameters.partNumber)
								);
								dispatch(
									selectedDesignSlice.actions.setTopology(response.data.designDetail.rankingParameters.topology)
								);
							}
						} else {
							dispatch(selectedDesignSlice.actions.setMyDesignId(0));
						}
					} catch (e) {
						console.error('Error fetching data for Design Page:', e);
						setHasError(true);
					}
				})
				.catch(() => {
					dispatch(selectedDesignSlice.actions.setMyDesignId(0));
					setHasError(true);
				})
				.finally(() => {
					dispatch(tabbarSlice.actions.setProgressActive(false));
					dispatch(selectedDesignSlice.actions.setFetchDesignData(false));
					dispatch(selectedDesignSlice.actions.setOpenMyDesign(false));
				});
		}, 300);

		return () => {
			clearTimeout(timer);
		};
	}, [dispatch, disabledTabs, icPartNumber, inputParametersDL, openMyDesign, topology, userId, userLoggedIn]);

	return hasError;
};

export default useFetchData;
